import { render, staticRenderFns } from "./TestProgressTable.vue?vue&type=template&id=04e1dccc&scoped=true&"
import script from "./TestProgressTable.vue?vue&type=script&lang=js&"
export * from "./TestProgressTable.vue?vue&type=script&lang=js&"
import style0 from "./TestProgressTable.vue?vue&type=style&index=0&id=04e1dccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1dccc",
  null
  
)

export default component.exports